import { TURNSTILE_CONTAINER_ID } from "$templates/components/TurnstileContainer"
import htmx, { HttpVerb } from "htmx.org"

declare global {
  interface Window {
    turnstile: {
      reset: (data?: any) => void
      execute: (data?: any) => Promise<void>
      render: (element: string, options: Record<string, any>) => string
    }
    RECAPTCHA_ACTIVE: boolean
    RECAPTCHA_SITE_KEY: string
    RECAPTCHA_MANUAL_SITE_KEY: string
    turnstileToken: {
      loading: boolean
      value: string
    }
    renderManualTurnstile: () => void
  }
}

window.turnstileToken = {
  loading: false,
  value: "",
}

export const generateToken = async() => {
  window.turnstileToken = {
    loading: true,
    value: "",
  }
  const token = await getToken()
  window.turnstileToken = {
    loading: false,
    value: token,
  }
}

const getToken = (): Promise<string> => {
  if (!window.RECAPTCHA_ACTIVE || !window.turnstile || !window.RECAPTCHA_SITE_KEY) {
    return Promise.resolve("")
  }
  
  return new Promise((resolve) => {
    const widgetId = window.turnstile.render(`#${TURNSTILE_CONTAINER_ID}`, {
      sitekey: window.RECAPTCHA_SITE_KEY,
      execution: "execute",
      size: "flexible",
      appearance: "interaction-only",
      callback: (token: string) => {
        resolve(token)
      },
      "expired-callback": () => {
        void generateToken()
      },
    })

    window.turnstile.reset(widgetId);
    window.turnstile.execute(widgetId);
  })
}

window.renderManualTurnstile = () => {
  const widget = window.turnstile.render(`#turnstile-container-manual`, {
    sitekey: window.RECAPTCHA_MANUAL_SITE_KEY,
    size: "normal",
    appearance: "execute",
    execution: "execute",
    callback: (token: string) => {
      const container = document.getElementById("turnstile-container-manual")
      const method = (container?.getAttribute("data-form-method")?.toLowerCase() || "post") as HttpVerb
      const action = container?.getAttribute("data-form-action") || "/"
      let values: Record<string, any> = {}
      try {
        values = JSON.parse(container?.getAttribute("data-form-values") ?? "{}") as Record<string, any>
        values["cf-turnstile-response"] = token
      } catch (e) {}
      
      htmx.ajax(method, action, {
        headers: {
          "HX-Turnstile-Manual": "true"
        },
        values 
      })

      window.closeModal("turnstile-manual-modal")
    },
  })

  window.turnstile.reset(widget)
  window.turnstile.execute(widget)
}
